import React from 'react';

const Ohio = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Ohio Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>
          Residential Property Disclosure Form: Mandatory for residential sales.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure
          </span>
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/08/Ohio-Residential-Property-Disclosure-Form.pdf',
                '_blank'
              );
            }}
          >
            {' '}
            Residential Property Disclosure Form{' '}
          </span>
          – When selling a residential property, the owner must describe its
          condition using this disclosure statement. It must be provided to the
          buyer before the agreement is signed.
        </li>
      </ol>
    </div>
  );
};

export default Ohio;
